export default __webpack_public_path__ + "static/media/Korek.127e7054.png";